import React, { useState } from 'react';

const ToggleButton = ({ isChecked, setIsChecked }) => {
  

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <label className="flex items-center cursor-pointer">
      {/* Hidden Checkbox */}
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleCheckboxChange}
        className="sr-only"
      />
      {/* Toggle Background */}
      <div
        className={`relative h-8 w-16 rounded-full transition-colors duration-300 ${
          isChecked ? 'bg-green-500' : 'bg-gray-300'
        }`}
      >
        {/* Toggle Dot */}
        <div
          className={`absolute top-1 left-1 h-6 w-6 transform rounded-full bg-white shadow-md transition-transform duration-300 ${
            isChecked ? 'translate-x-8' : 'translate-x-0'
          }`}
        />
      </div>
    </label>
  );
};

export default ToggleButton;
